<div class="martingale-strategy-options-edit">
    <div class="form-group">
        <div class="custom-label" for="rSILowerLimit">RSI(2) Lower Limit</div>
        <mat-form-field class="w-100">
            <input
                matInput
                type="number"
                class="col-12 w-100"
                id="rSILowerLimit"
                [(ngModel)]="options.rsiLowerLimit"
                (ngModelChange)="onOptionsChange()"
                min="0"
        /></mat-form-field>
    </div>

    <div class="form-group">
        <div class="custom-label" for="rSIUpperLimit">RSI(2) Upper Limit</div>
        <mat-form-field class="w-100">
            <input
                matInput
                type="number"
                class="col-12 w-100"
                id="rSIUpperLimit"
                [(ngModel)]="options.rsiUpperLimit"
                (ngModelChange)="onOptionsChange()"
                min="0"
        /></mat-form-field>
    </div>

    <div class="form-group">
        <div class="custom-label" for="minProfitLimitForSell">Minimal Profit(%) For Sell</div>
        <mat-form-field class="w-100">
            <input
                matInput
                type="number"
                class="col-12 w-100"
                id="minProfitLimitForSell"
                [(ngModel)]="options.minProfitLimitForSell"
                (ngModelChange)="onOptionsChange()"
                min="0"
        /></mat-form-field>
    </div>

    <div class="form-group">
        <mat-slide-toggle id="buyBelowMA200" [(ngModel)]="options.buyBelowMA200" (ngModelChange)="onOptionsChange()">
            Buy Below MA(200)
        </mat-slide-toggle>
    </div>

    <div class="form-control">
        <button mat-flat-button class="rounded-1" (click)="addBid()">Add bid</button>
        <table class="table table-striped table-bordered table-hover">
            <thead>
                <tr>
                    <th scope="col">Index</th>
                    <th scope="col">Coefficient</th>
                    <th scope="col">Minimal price drop with previous bid</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                @for (bid of options.bids; track bid.purchaseIndex) {
                    <tr>
                        <td>
                            <input
                                type="number"
                                class="col-12"
                                id="bidIndex"
                                [(ngModel)]="bid.purchaseIndex"
                                (ngModelChange)="onBidChange()"
                                min="0"
                            />
                        </td>
                        <td>
                            <input
                                type="number"
                                class="col-12"
                                id="bidCoefficient"
                                [(ngModel)]="bid.bidCoefficient"
                                (ngModelChange)="onBidChange()"
                                min="0"
                            />
                        </td>
                        <td>
                            <input
                                type="number"
                                class="col-12"
                                id="minPriceDropWithPrevBid"
                                [(ngModel)]="bid.minPriceDropWithPrevBid"
                                (ngModelChange)="onBidChange()"
                                min="0"
                            />
                        </td>
                        <td>
                            <button
                                mat-icon-button
                                color="warn"
                                class="rounded-1"
                                (click)="removeBid(bid.purchaseIndex)"
                            >
                                <fa-icon [icon]="['fas', 'trash']" />
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
